import { ProductGallery } from './product-gallery';
import { ProductVariantForm } from './product-variants';

export function init() {
	let formElement = document.querySelector('.js-product-form');
	let galleryElement = document.querySelector('.js-product-gallery');

	let form = ProductVariantForm(formElement);
	let gallery = ProductGallery(galleryElement);

	let swatches = Array.from(document.querySelectorAll('.js-swatch-input'));

	if (!form || !gallery) {
		return;
	}

	swatches.forEach(swatch => {
		swatch.addEventListener('change', function() {
			gallery.selectByVariant(swatch.dataset.color);
		});
	});
}
